(function () {
  "use strict";

  var config = window.fishkillRecipeCta || null;
  var pendingIds = {};

  function cartLabel(qty) {
    var format = config && config.inCart ? config.inCart : "%d in Cart";
    return format.replace("%d", String(qty));
  }

  function atMax(qty, max) {
    return max >= 0 && qty >= max;
  }

  function variationIsBuyable(variation) {
    return !!(
      variation &&
      variation.is_purchasable !== false &&
      variation.is_in_stock !== false &&
      variation.variation_is_visible !== false &&
      variation.variation_is_active !== false
    );
  }

  function variationMax(variation) {
    var raw = variation.max_qty;

    if (raw === "" || raw === null || typeof raw === "undefined") {
      return -1;
    }

    var max = Number(raw);
    return isNaN(max) ? -1 : max;
  }

  function lineFor(addId) {
    var lines = config && config.cartLines ? config.cartLines : {};
    var line = lines[String(addId)];

    if (!line) {
      return { qty: 0, key: "" };
    }

    return {
      qty: Number(line.qty) || 0,
      key: line.key || "",
    };
  }

  function rememberCart(cart) {
    var items = cart && cart.items ? cart.items : [];
    var next = {};
    var i;

    for (i = 0; i < items.length; i += 1) {
      next[String(items[i].id)] = {
        key: items[i].key || "",
        qty: Number(items[i].quantity) || 0,
      };
    }

    config.cartLines = next;
    paintHeaderCartCount(cart);
  }

  function paintHeaderCartCount(cart) {
    var count = 0;
    var items;
    var i;

    if (cart && typeof cart.items_count === "number") {
      count = cart.items_count;
    } else if (cart && cart.items) {
      items = cart.items;

      for (i = 0; i < items.length; i += 1) {
        count += Number(items[i].quantity) || 0;
      }
    }

    document.querySelectorAll("[data-cart-count]").forEach(function (node) {
      node.textContent = String(count);
    });
  }

  function itemQty(cart, addId) {
    var items = cart && cart.items ? cart.items : [];
    var i;

    for (i = 0; i < items.length; i += 1) {
      if (Number(items[i].id) === addId) {
        return {
          qty: Number(items[i].quantity) || 0,
          key: items[i].key || "",
        };
      }
    }

    return { qty: 0, key: "" };
  }

  function initFishkillCart(root) {
    if (!root || root.dataset.fishkillBound === "1" || !config || !config.storeApi) {
      return;
    }

    var addBtn = root.querySelector(".fishkill-atc");
    var qtyEl = root.querySelector(".fishkill-qty");
    var label = root.querySelector(".fishkill-qty__label");
    var minusBtn = root.querySelector("[data-fishkill-minus]");
    var plusBtn = root.querySelector("[data-fishkill-plus]");
    var cartToken = "";

    if (!addBtn || !qtyEl || !label) {
      return;
    }

    root.dataset.fishkillBound = "1";

    function currentId() {
      return Number(root.dataset.addId) || 0;
    }

    function currentMax() {
      return Number(root.dataset.max);
    }

    function currentMin() {
      var min = Number(root.dataset.min);
      return min > 0 ? min : 1;
    }

    function currentStep() {
      var step = Number(root.dataset.step);
      return step > 0 ? step : 1;
    }

    function render(qty, key) {
      var id = currentId();
      var max = currentMax();

      root.dataset.qty = String(qty);
      root.dataset.cartKey = key || "";
      label.textContent = cartLabel(qty);

      if (id < 1) {
        addBtn.hidden = false;
        addBtn.disabled = true;
        qtyEl.hidden = true;
        return;
      }

      if (qty > 0) {
        addBtn.hidden = true;
        qtyEl.hidden = false;
      } else {
        addBtn.hidden = false;
        addBtn.disabled = false;
        qtyEl.hidden = true;
      }

      if (minusBtn) {
        minusBtn.disabled = false;
      }

      if (plusBtn) {
        plusBtn.disabled = atMax(qty, max);
      }
    }

    function sync(addId, max, min, step) {
      var line = lineFor(addId);

      root.dataset.addId = String(addId || 0);
      if (typeof max === "number" && !isNaN(max)) {
        root.dataset.max = String(max);
      }
      if (typeof min === "number" && !isNaN(min) && min > 0) {
        root.dataset.min = String(min);
      }
      if (typeof step === "number" && !isNaN(step) && step > 0) {
        root.dataset.step = String(step);
      }
      render(line.qty, line.key);
    }

    root._fishkillSync = sync;
    root._fishkillRender = render;

    function setPending(isPending, addId) {
      pendingIds[addId] = isPending;
      document.querySelectorAll("[data-fishkill-cart]").forEach(function (other) {
        if (Number(other.dataset.addId) !== addId) {
          return;
        }

        var otherAdd = other.querySelector(".fishkill-atc");
        var otherMinus = other.querySelector("[data-fishkill-minus]");
        var otherPlus = other.querySelector("[data-fishkill-plus]");

        if (otherAdd && addId > 0) {
          otherAdd.disabled = isPending;
        }
        if (otherMinus) {
          otherMinus.disabled = isPending;
        }
        if (otherPlus && isPending) {
          otherPlus.disabled = true;
        }
        if (!isPending && other._fishkillRender) {
          other._fishkillRender(Number(other.dataset.qty) || 0, other.dataset.cartKey || "");
        }
      });
    }

    function request(path, body) {
      var headers = {
        "Content-Type": "application/json",
        Nonce: config.nonce || "",
      };

      if (cartToken) {
        headers["Cart-Token"] = cartToken;
      }

      return fetch(config.storeApi.replace(/\/$/, "") + path, {
        method: "POST",
        credentials: "same-origin",
        headers: headers,
        body: JSON.stringify(body),
      }).then(function (res) {
        var nextNonce = res.headers.get("Nonce");
        var nextToken = res.headers.get("Cart-Token");

        if (nextNonce) {
          config.nonce = nextNonce;
        }
        if (nextToken) {
          cartToken = nextToken;
        }

        if (!res.ok) {
          throw new Error("cart");
        }

        return res.json();
      });
    }

    function paintAll(cart, addId) {
      var match = itemQty(cart, addId);

      rememberCart(cart);
      document.querySelectorAll("[data-fishkill-cart]").forEach(function (other) {
        if (Number(other.dataset.addId) === addId && other._fishkillRender) {
          other._fishkillRender(match.qty, match.key);
        }
      });
    }

    function run(task, addId) {
      if (pendingIds[addId] || addId < 1) {
        return;
      }

      setPending(true, addId);
      task()
        .then(function (cart) {
          paintAll(cart, addId);
          document.dispatchEvent(new CustomEvent("fishkill-cart-changed"));
        })
        .catch(function () {
          render(Number(root.dataset.qty) || 0, root.dataset.cartKey || "");
        })
        .finally(function () {
          setPending(false, addId);
        });
    }

    addBtn.addEventListener("click", function () {
      var addId = currentId();

      run(function () {
        return request("/cart/add-item", { id: addId, quantity: currentMin() });
      }, addId);
    });

    if (minusBtn) {
      minusBtn.addEventListener("click", function () {
        var qty = Number(root.dataset.qty) || 0;
        var key = root.dataset.cartKey || "";
        var addId = currentId();

        if (!key || qty < 1) {
          return;
        }

        run(function () {
          var next = qty - currentStep();

          if (next < currentMin()) {
            return request("/cart/remove-item", { key: key });
          }

          return request("/cart/update-item", { key: key, quantity: next });
        }, addId);
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener("click", function () {
        var qty = Number(root.dataset.qty) || 0;
        var key = root.dataset.cartKey || "";
        var addId = currentId();
        var max = currentMax();

        if (atMax(qty, max)) {
          return;
        }

        run(function () {
          if (!key) {
            return request("/cart/add-item", { id: addId, quantity: currentMin() });
          }

          return request("/cart/update-item", { key: key, quantity: qty + currentStep() });
        }, addId);
      });
    }
  }

  function paintCardBadge(badge, data) {
    var mods = [
      "product-card__badge--out-of-stock",
      "product-card__badge--low-stock",
      "product-card__badge--sale",
    ];

    if (!badge) {
      return;
    }

    mods.forEach(function (name) {
      badge.classList.remove(name);
    });

    if (!data || !data.modifier) {
      badge.hidden = true;
      badge.textContent = "";
      return;
    }

    badge.hidden = false;
    badge.classList.add("product-card__badge--" + data.modifier);
    badge.textContent = data.label || "";
  }

  function accountRedirect(accountUrl, back) {
    if (!accountUrl) {
      return back || "#";
    }

    return accountUrl + (accountUrl.indexOf("?") === -1 ? "?" : "&") + "redirect=" + encodeURIComponent(back || "");
  }

  function variationMatches(variation, selected) {
    var attrs = variation.attributes || {};
    var keys = Object.keys(attrs);
    var i;

    for (i = 0; i < keys.length; i += 1) {
      if (attrs[keys[i]] && attrs[keys[i]] !== selected[keys[i]]) {
        return false;
      }
    }

    return true;
  }

  function findCardVariation(data, selected) {
    var rows = data.rows || [];
    var variations = data.variations || [];
    var i;

    for (i = 0; i < rows.length; i += 1) {
      if (!selected[rows[i]]) {
        return null;
      }
    }

    for (i = 0; i < variations.length; i += 1) {
      if (variationMatches(variations[i], selected)) {
        return variations[i];
      }
    }

    return null;
  }

  function setSlot(el, on) {
    if (el) {
      el.hidden = !on;
    }
  }

  function showIdleCart(cartSlot, notify, selectSlot, cart) {
    setSlot(cartSlot, true);
    setSlot(notify, false);
    setSlot(selectSlot, false);
    if (cart && cart._fishkillSync) {
      cart._fishkillSync(0, 0);
      return;
    }
    if (!cart) {
      return;
    }
    cart.dataset.addId = "0";
    var addBtn = cart.querySelector(".fishkill-atc");
    var qtyEl = cart.querySelector(".fishkill-qty");
    if (addBtn) {
      addBtn.hidden = false;
      addBtn.disabled = true;
    }
    if (qtyEl) {
      qtyEl.hidden = true;
    }
  }

  function applyCardState(card, data, selected) {
    var variation = findCardVariation(data, selected);
    var price = card.querySelector(".product-card__price");
    var badge = card.querySelector(".product-card__badge");
    var cartSlot = card.querySelector("[data-product-card-cart]");
    var notify = card.querySelector("[data-product-card-notify]");
    var selectSlot = card.querySelector("[data-product-card-select]");
    var cart = card.querySelector("[data-fishkill-cart]");
    var line;
    var canBuy;

    if (!variation) {
      if (price) {
        price.innerHTML = data.priceHtml || "";
      }
      paintCardBadge(badge, null);
      showIdleCart(cartSlot, notify, selectSlot, cart);
      return;
    }

    if (price) {
      price.innerHTML = variation.priceHtml || "";
    }
    paintCardBadge(badge, variation.badge);

    line = lineFor(variation.id);
    canBuy = variation.purchasable && variation.inStock;

    if (canBuy || line.qty > 0) {
      setSlot(cartSlot, true);
      setSlot(notify, false);
      setSlot(selectSlot, false);
      if (cart && cart._fishkillSync) {
        cart._fishkillSync(variation.id, variation.maxQty, variation.minQty, variation.stepQty);
      } else if (cart) {
        cart.dataset.addId = String(variation.id);
        cart.dataset.max = String(variation.maxQty);
        cart.dataset.min = String(variation.minQty);
        cart.dataset.step = String(variation.stepQty);
      }
      return;
    }

    if (!variation.inStock) {
      setSlot(cartSlot, false);
      setSlot(selectSlot, false);
      setSlot(notify, true);
      if (notify && notify.tagName === "FORM") {
        var input = notify.querySelector('[name="wc_bis_product_id"]');
        if (input) {
          input.value = String(variation.id);
        }
      } else if (notify && notify.tagName === "A") {
        notify.href = accountRedirect(data.accountUrl, variation.permalink || data.permalink);
      }
      return;
    }

    showIdleCart(cartSlot, notify, selectSlot, cart);
  }

  function initProductCard(card) {
    var dataEl = card.querySelector(".product-card__data");
    var data;
    var selected = {};

    if (!dataEl || card.dataset.productCardBound === "1") {
      return;
    }

    try {
      data = JSON.parse(dataEl.textContent || "");
    } catch (error) {
      return;
    }

    if (!data || !data.rows || !data.rows.length) {
      return;
    }

    card.dataset.productCardBound = "1";
    card.querySelectorAll(".product-card__pill.is-selected").forEach(function (pill) {
      selected[pill.getAttribute("data-attribute")] = pill.getAttribute("data-value");
    });

    card.querySelectorAll(".product-card__pill").forEach(function (pill) {
      pill.addEventListener("click", function () {
        var key = pill.getAttribute("data-attribute");
        var row = pill.closest(".product-card__option-row");

        if (row) {
          row.querySelectorAll(".product-card__pill").forEach(function (other) {
            var on = other === pill;
            other.classList.toggle("is-selected", on);
            other.setAttribute("aria-pressed", on ? "true" : "false");
          });
        }

        selected[key] = pill.getAttribute("data-value");
        applyCardState(card, data, selected);
      });
    });
  }

  function initFishkillCarts() {
    document.querySelectorAll("form.cart, form.variations_form").forEach(function (form) {
      if (form.querySelector("[data-fishkill-cart]")) {
        form.classList.add("fishkill-atc-enhanced");
      }
    });

    document.querySelectorAll("[data-fishkill-cart]").forEach(initFishkillCart);
    document.querySelectorAll("[data-product-card]").forEach(initProductCard);

    if (!window.jQuery) {
      return;
    }

    window.jQuery(document.body).on("found_variation", "form.variations_form", function (event, variation) {
      var root = this.querySelector("[data-fishkill-cart]");

      if (!root || !root._fishkillSync || !variation) {
        return;
      }

      if (!variationIsBuyable(variation)) {
        root._fishkillSync(0, 0);
        return;
      }

      root._fishkillSync(
        Number(variation.variation_id) || 0,
        variationMax(variation),
        Number(variation.min_qty) || 1,
        1
      );
    });

    window.jQuery(document.body).on("reset_data", "form.variations_form", function () {
      var root = this.querySelector("[data-fishkill-cart]");

      if (root && root._fishkillSync) {
        root._fishkillSync(0, 0);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFishkillCarts);
  } else {
    initFishkillCarts();
  }
})();
